import React from 'react';
import { Box, TextField } from '@mui/material';

interface YearCbsaFieldsProps {
    year: number;
    cbsa: string;
    yearError?: string;
    cbsaError?: string;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export const YearCbsaFields: React.FC<YearCbsaFieldsProps> = ({
    year,
    cbsa,
    yearError,
    cbsaError,
    onChange
}) => {
    return (
        <>
            <Box>
                <TextField
                    label="Year"
                    name="year"
                    type="number"
                    value={year}
                    onChange={onChange}
                    fullWidth
                    required
                    error={!!yearError}
                    helperText={yearError}
                    inputProps={{
                        min: 1900,
                        max: 2100,
                        step: 1
                    }}
                />
            </Box>

            <Box>
                <TextField
                    label="CBSA"
                    name="cbsa"
                    type="text"
                    value={cbsa}
                    onChange={onChange}
                    fullWidth
                    required
                    error={!!cbsaError}
                    helperText={cbsaError}
                />
            </Box>
        </>
    );
};
